import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';

import AuthSimpleRoutes from 'components/authentication/AuthSimpleRoutes';
import Logo from 'components/common/Logo';
import Section from 'components/common/Section';
import { getText } from 'function/language';

/**
 * 로그인 레이아웃
 */
const AuthLayout = () => (
  <Section className="py-0">
    <Row className="flex-center min-vh-100 py-6">
      <Col sm={10} md={8} lg={6} xl={5} className="col-xxl-4">
        <Logo width={336} />
        <p className="fs-0 text-black text-center">{getText('sfims')}</p>
        <Card>
          <Card.Body className="p-4 p-sm-5">
            <AuthSimpleRoutes />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </Section>
);

export default AuthLayout;
